export default "__VITE_ASSET__DzAQcYTX__"